/* Ayudate · Navegación entre páginas */

/* El sitio público es una sola página con anclas; estas rutas son las que sí
   necesitan dirección propia. Vive aparte de App.jsx para que las páginas
   puedan navegar sin importar al enrutador (dependencia circular).         */
export const RUTAS = [
  "/", "/tutores", "/preguntas", "/nosotros", "/calificar", "/sala", "/admin", "/pagar",
  "/login", "/paneltutor", "/restablecer-password",
  "/crear-cuenta-estudiante", "/panelestudiante", "/restablecer-password-estudiante",
];

export function normalizar(p) {
  return "/" + String(p || "").replace(/^\/+|\/+$/g, "");
}

/**
 * Navega sin recargar la página.
 * @param {string} ruta   destino, p. ej. "/tutores"
 * @param {string} desde  página de origen, para el botón de volver
 */
export function irA_ruta(ruta, desde = null) {
  window.history.pushState(desde ? { desde } : {}, "", ruta);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
